import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type TypographyMaskProps = Omit<
  HTMLAttributes<HTMLSpanElement>,
  'children'
> & {
  children: JSX.Element
}

const TypographyMask = forwardRef<HTMLSpanElement, TypographyMaskProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <span
        ref={ref}
        data-label={children?.props?.children}
        className={cn(
          'relative inline-flex overflow-hidden',
          'after:font-roboto after:text-regular after:content-[attr(data-label)]',
          'after:absolute after:left-0 after:top-0 after:h-full after:w-full after:translate-y-[95%]',
          'after:transition-transform after:duration-500 after:ease-out-cubic',
          '[&_span]:my-0 [&_span]:inline-flex [&_span]:grow',
          '[&_span]:transition-transform [&_span]:duration-500 [&_span]:ease-out-cubic',
          'group-hover:after:translate-y-0 [&_span]:group-hover:-translate-y-[95%]',
          className
        )}
        {...props}
      >
        {children}
      </span>
    )
  }
)

export default TypographyMask
